import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1f649917&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=1f649917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f649917",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f649917')) {
      api.createRecord('1f649917', component.options)
    } else {
      api.reload('1f649917', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=1f649917&scoped=true&", function () {
      api.rerender('1f649917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/Notifications.vue"
export default component.exports